import classcat from "classcat";
import React from "react";

import BasketItems from "@is/components/BasketItems";
import { CheckoutConfigurationType } from "@is/constants";
import {
  DELIVERY_OPTIONS_LABELS,
  DeliveryOptions,
} from "@is/constants/checkout";
import { FieldState } from "@is/types";

import css from "./DeliveryInformation.module.css";
import useManageDeliveryInformation from "./hooks/useManageDeliveryInformation";

type Props = {
  recipientOptions?: FieldState[];
  deliveryOptions?: FieldState[];
  checkoutConfigurationsType: CheckoutConfigurationType;
  storeName: string;
  storeAddress: string;
  isInstorePickupOptionSelected: boolean;
};

const DeliveryInformation = ({
  recipientOptions,
  deliveryOptions,
  checkoutConfigurationsType,
  storeName,
  storeAddress,
  isInstorePickupOptionSelected,
}: Props) => {
  const {
    t,
    hasPersonalInformation,
    hasDeliveryInformation,
    firstAndLastName,
    phoneNumber,
    email,
    phoneOrEmail,
    address,
    location,
  } = useManageDeliveryInformation({
    recipientOptions,
    deliveryOptions,
  });

  return (
    <div className={css.container}>
      <div className={classcat(["text-label-lg", css.content])}>
        <div className={css.section}>
          <BasketItems isCheckout isSummary />
        </div>
        {hasPersonalInformation && (
          <div className={classcat([css.infoSection, css.section])}>
            <div className={classcat([css.titleContainer])}>
              {t("Your information")}
            </div>
            <div className={css.infoContainer}>
              {!!firstAndLastName?.length && (
                <span className={css.info}>{firstAndLastName}</span>
              )}
              {!!phoneNumber?.length && (
                <span className={css.info}>{phoneNumber}</span>
              )}
              {!!email?.length && <span className={css.info}>{email}</span>}
              {!!phoneOrEmail?.length && (
                <span className={css.info}>{phoneOrEmail}</span>
              )}
            </div>
          </div>
        )}
        {isInstorePickupOptionSelected && (
          <div className={classcat([css.infoSection, css.section])}>
            <div className={classcat([css.titleContainer])}>
              <span>{t("Delivery address")}</span>
              {isInstorePickupOptionSelected && (
                <div className={css.inStoreTag}>
                  <span className="text-label-sm">
                    {t(DELIVERY_OPTIONS_LABELS[DeliveryOptions.InstorePickup])}
                  </span>
                </div>
              )}
            </div>
            <div className={css.inStoreOption}>
              <span className={css.storeName}>{storeName}</span>
              <span className={css.storeAddress}>{storeAddress}</span>
            </div>
          </div>
        )}
        {hasDeliveryInformation && !isInstorePickupOptionSelected && (
          <div className={classcat([css.infoSection, css.section])}>
            <div className={classcat([css.titleContainer])}>
              <span>{t("Delivery address")}</span>
            </div>
            <div className={css.infoContainer}>
              {!!address?.length && <span className={css.info}>{address}</span>}
              {!!location?.length && (
                <span className={css.info}>{location}</span>
              )}
            </div>
          </div>
        )}
        {checkoutConfigurationsType ===
          CheckoutConfigurationType.PayAtCounter && (
          <div className={classcat([css.infoSection, css.section])}>
            <div className={classcat([css.titleContainer])}>
              {t("Payments")}
            </div>
            <span className={css.info}>{t("Pay at the counter")}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeliveryInformation;
